import ObjectCache from './CacheService';
import LogicBaseCollectionSubscriptionApi from '../server/LogicBaseCollectionSubscriptionApi';
import UserAccount from '../UserAccount';
import LogicBaseCollectionSubscription from '../../models/logicbasecollectionsubscription';

class LogicBaseCollectionSubscriptionCache extends ObjectCache {
  api = LogicBaseCollectionSubscriptionApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseCollectionSubscription(results._id, results.fr, results.c, results.es, results.dn, results.sa);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseCollectionSubscriptionCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
